<div class="w-full">
    <mat-dialog-content>
        <h2 mat-dialog-title>{{ title | translate }}</h2>
        <form [formGroup]="form" class="">
            <mat-form-field class="w-full" appearance="fill">
                <mat-label>{{ label| translate }}</mat-label>
                <input matInput [formControl]="controls.data" placeholder="{{ placeholder | translate }}">
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="w-full flex justify-between">
        <button mat-flat-button mat-dialog-close class="flex-grow bg-tw-disabled">{{ 'CANCEL' | translate }}</button>
        <button mat-flat-button [mat-dialog-close]="true" class="flex-grow bg-tw-primary text-tw-text-light" [disabled]="!isValid" (click)="submit()">{{ valid | translate }}</button>
    </mat-dialog-actions>
</div>